import { Configuration } from '@azure/msal-browser';
import { ActivityTypeId } from '../graph/schema-generated-types-educator';
import { isStudentApp } from '../util/app-util';
import CommonConfig from './common';

export interface Config {
  auth: Configuration | null;
  activityTypeFactory?: (activityType: ActivityTypeId) => { icon: string };
  MIME_TYPE_MAP: { [key: string]: string };
  internalResourceTypes?: ActivityTypeId[];
  logoutUrl: string;
  loginUrl: string;
  graphUrl: string;
  companyUrl: string;
  hiddenRoutes: string[];
  isQA: boolean;
  userMediaPrivilege: any;
  productFamilyCode?: string;
  productFamilyCodeStudent?: string;
  pliUrl?: string;
  digitalProductSupportUrl?: string;
  digitalAssetsUrl?: string;
}

type Environment = 'dev' | 'dev-next' | 'qa01' | 'stage' | 'production' | 'demo';

export const isQA = (env: string): boolean => env === 'qa01' || env === 'dev' || env === 'dev-next';

const getConfig = (env: Environment, { graphUrl, loginUrl }): Config => {
  const app = process.env?.REACT_APP_APP_NAME === 'mat-man-educator' ? 'educatorApp' : 'studentApp';
  // eslint-disable-next-line @typescript-eslint/no-var-requires
  const Config = env ? require(`./${app}/${env}`).default : require(`./${app}/dev`).default;
  const auth = isStudentApp
    ? null
    : // eslint-disable-next-line @typescript-eslint/no-var-requires
      require(`./${app}/auth`).default;

  return {
    ...CommonConfig,
    ...Config,
    graphUrl,
    loginUrl,
    auth,
    isQA: isQA(env),
  };
};

export default getConfig(process.env.REACT_APP_BUILD_ENV as Environment, {
  graphUrl: process.env.REACT_APP_GRAPH_URL,
  loginUrl: process.env.REACT_APP_LOGIN_URL,
});

// this is #notgood - more comprehensive solution should be figured out
const FILE_PATH_MAP = {
  WDT: {
    PRINT: {
      LOWERCASE: 'Print lowercase',
      UPPERCASE: 'Print CAPITALS',
    },
    CURSIVE: {
      LOWERCASE: 'Cursive lowercase',
      UPPERCASE: 'Cursive CAPITALS',
      CONNECTION: 'Cursive Connections',
    },
    NUMBER: '123',
  },
};
export const getFilePath = ({ application, characterCase, characterType, character }): string => {
  if (!characterCase)
    return `${application}/${FILE_PATH_MAP[application][characterType]}/${character}`;

  return `${application}/${FILE_PATH_MAP[application][characterType][characterCase]}/${character}`;
};
